import { Navigate } from "react-router-dom";
import { EmptyState, Page, Table } from "@marekl/adminer/components";
import { AppTopbar } from "../../../shell/AppTopbar";
import { useMyTeams, type Team } from "../../../lib/queries/teams";

export function MembershipPage() {
  const { data: teams = [], isLoading } = useMyTeams();
  const activeTeams = teams.filter((t) => t.status === "active");

  if (activeTeams.length === 1) {
    return <Navigate to={`/teams/${activeTeams[0].id}`} replace />;
  }

  return (
    <>
      <AppTopbar crumbs={[{ label: "Členská základna" }]} />
      <Page>
        <Page.Header title="Členská základna" subtitle="správa členů týmů" />
        <Page.Content stack gap="lg">
          <Table<Team>
            framed
            rows={activeTeams}
            rowKey={(team) => team.id}
            columns={[
              {
                key: "name",
                header: "Tým",
                linkTo: (team) => `/teams/${team.id}`,
                render: (team) => team.name,
              },
              {
                key: "cmf_id",
                header: "ČNSMS ID",
                render: (team) => team.cmf_id ?? "—",
              },
            ]}
            isLoading={isLoading}
            empty={
              <EmptyState
                title="Žádný aktivní tým"
                description="Nemáte přiřazený žádný aktivní tým ke správě."
              />
            }
          />
        </Page.Content>
      </Page>
    </>
  );
}
